import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Bewerbung.css';
import { host_url } from '../../../App'; // Import host_url
import Cookies from 'js-cookie'; // Import js-cookie
import { MdOutlineCasino, MdKeyboardArrowDown } from "react-icons/md"; // MdArrowDropDown durch MdKeyboardArrowDown ersetzt
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente

function Bewerbung() {
  const [page, setPage] = useState(1);
  const [zelte, setZelte] = useState([]); // State to store zelte data
  const [kinder, setKinder] = useState([]); // State to store kinder data
  const [selectedZelt, setSelectedZelt] = useState(""); // State to store selected zelt
  const [selectedKind, setSelectedKind] = useState(""); // State to store selected kind
  const [einheiten, setEinheiten] = useState([]); // State to store einheiten data
  const [selectedEinheit, setSelectedEinheit] = useState(""); // State to store selected einheit
  const [filteredJobs, setFilteredJobs] = useState([]); // State to store filtered jobs
  const [selectedZeltName, setSelectedZeltName] = useState(""); // State to store selected zelt name
  const [selectedKindName, setSelectedKindName] = useState(""); // Name des gewählten Kindes (bleibt für Anzeige erhalten)
  const [submissionCount, setSubmissionCount] = useState(0); // To trigger kinder list refresh
  const [hasSelection, setHasSelection] = useState(false); // Mind. eine Prio gewählt -> Absenden erlaubt

  useEffect(() => {
    fetch(`${host_url}/zelte`) // Use host_url
      .then(response => response.json())
      .then(data => {
        const sorted = data.sort((a, b) => a.Zeltname.localeCompare(b.Zeltname));
        setZelte(sorted);
      })
      .catch(error => {
        console.error('Error fetching zelte:', error);
        alert('Fehler beim Laden der Zelte. Bitte versuche es später erneut.');
      });
  }, []);

  useEffect(() => {
    // Fetch kinder only if both Zelt and Einheit are selected
    if (selectedZelt && selectedEinheit) {
      fetch(`${host_url}/kinderFuerBewerbung?zeltId=${selectedZelt}&einheitId=${selectedEinheit}`) // Use host_url
        .then(response => response.json())
        .then(data => {
          const sorted = data.sort((a, b) => a.Name.localeCompare(b.Name));
          setKinder(sorted);
          // Ein aus der vorherigen Bewerbung behaltenes Kind nur dann weiter
          // ausgewählt lassen, wenn es sich in dieser Einheit noch nicht
          // beworben hat (sonst ist es nicht in der Liste -> zurücksetzen).
          setSelectedKind(prevKind => {
            if (prevKind && !sorted.some(k => Number(k.KindID) === Number(prevKind))) {
              return "";
            }
            return prevKind;
          });
        })
        .catch(error => {
          console.error('Error fetching kinder for bewerbung:', error);
        });
    } else {
      setKinder([]); // Clear kinder if Zelt or Einheit is not selected
    }
  }, [selectedZelt, selectedEinheit, submissionCount]); // Add selectedEinheit and submissionCount as dependencies

  useEffect(() => {
    fetch(`${host_url}/einheiten`) // Use host_url
      .then(response => response.json())
      .then(data => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Mitternacht, sonst fallen heutige Einheiten raus
        const upcomingEinheiten = data.filter(einheit => new Date(einheit.Datum) >= today);
        upcomingEinheiten.sort((a, b) => new Date(a.Datum) - new Date(b.Datum));
        setEinheiten(upcomingEinheiten.slice(0, 4));
      })
      .catch(error => {
        console.error('Error fetching einheiten:', error);
        alert('Fehler beim Laden der Einheiten. Bitte versuche es später erneut.');
      });
  }, []);

  useEffect(() => {
    if (selectedEinheit) {
      fetch(`${host_url}/jobs_verfuegbarkeiten?einheitId=${selectedEinheit}`) // Use host_url
        .then(response => response.json())
        .then(data => {
          const available = data.filter(job => job.Slots > 0);
          available.sort((a, b) => a.JobName.localeCompare(b.JobName));
          setFilteredJobs(available);
        })
        .catch(error => {
          console.error('Error fetching jobs:', error);
          // Optional: alert('Fehler beim Laden der Jobs für die ausgewählte Einheit.');
        });
    } else {
      setFilteredJobs([]);
    }
  }, [selectedEinheit]);

  useEffect(() => {
    const savedEinheitID = Cookies.get('selectedEinheit');
    const savedZeltID = Cookies.get('selectedZelt');
    const savedZeltName = Cookies.get('selected_zelt');
    if (savedEinheitID) setSelectedEinheit(savedEinheitID);
    if (savedZeltID) setSelectedZelt(savedZeltID);
    if (savedZeltName) setSelectedZeltName(savedZeltName);
  }, []);

  // Kind-Name immer mit der Auswahl synchron halten: wird das Kind (z. B. durch
  // Zelt-/Einheitswechsel oder Validierung) geleert, verschwindet auch der Name.
  useEffect(() => {
    if (!selectedKind) setSelectedKindName("");
  }, [selectedKind]);

  const handleNext = () => {
    setHasSelection(false); // Prio-Dropdowns auf Seite 2 starten leer
    setPage(page + 1);
  };
  const handleBack = () => setPage(page - 1);
  const handleSubmit = () => {
    const priorities = [
      document.querySelector('select[name="50"]').value,
      document.querySelector('select[name="40"]').value,
      document.querySelector('select[name="30"]').value,
      document.querySelector('select[name="20"]').value,
      document.querySelector('select[name="10"]').value,
    ];

    const requests = priorities
      .map((jobId, index) => jobId && ({
        EinheitID: selectedEinheit,
        KindID: selectedKind,
        JobID: jobId,
        Prioritaet: [50, 40, 30, 20, 10][index],
      }))
      .filter(request => request); // Filter out undefined requests

    if (requests.length === 0) {
      alert('Bitte wähle mindestens einen Job aus.');
      return;
    }

    fetch(`${host_url}/kinderwuensche`, { // Use host_url
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requests),
    })
      .then(response => {
        if (!response.ok) {
          return response.text().then(text => { throw new Error(text) });
        }
        return response.json();
      })
      .then(() => {
        setPage(3);
        setSubmissionCount(prevCount => prevCount + 1); // Increment to trigger kinder list refresh
        // Kind & Zelt bewusst beibehalten: im Camp steht dasselbe Kind meist
        // noch direkt vor einem und wird gleich für die nächste Einheit
        // eingetragen. Nur die Einheit wird geleert, damit man die nächste
        // Schicht auswählt (gleiches Kind + gleiche Einheit verhindert ohnehin
        // der Server-seitige Dublettenschutz).
        setSelectedEinheit("");
        Cookies.remove('selectedEinheit');
        Cookies.remove('selected_einheit');
      })
      .catch(error => {
        if (error.message.includes('ER_DUP_ENTRY')) {
          alert('Für dieses Kind wurden in dieser Einheit schon Wünsche abgesendet');
        } else {
          console.error('Error submitting form:', error);
          alert('Die Bewerbung konnte nicht abgesendet werden. Bitte versuche es erneut.');
        }
      });
  };
  const handleReset = () => {
    setPage(1);
    // selectedKind is already reset in handleSubmit
  };
  const handleZeltChange = (e) => {
    const zelt = e.target.value;
    if (zelt) {
      const selectedOption = e.target.options[e.target.selectedIndex];
      setSelectedZelt(zelt);
      setSelectedZeltName(selectedOption.text);
      setSelectedKind(""); // Reset selected kind when zelt changes
      Cookies.set('selectedZelt', zelt);
      Cookies.set('selected_zelt', selectedOption.text);
    } else {
      setSelectedZelt("");
      setSelectedZeltName("");
      setSelectedKind(""); // Also reset kind if zelt is deselected
      Cookies.remove('selectedZelt');
      Cookies.remove('selected_zelt');
    }
  };

  const handleEinheitChange = (e) => {
    const einheitValue = e.target.value;
    setSelectedEinheit(einheitValue); // Set state

    if (einheitValue) {
      const selectedOption = e.target.options[e.target.selectedIndex];
      Cookies.set('selectedEinheit', einheitValue);
      Cookies.set('selected_einheit', selectedOption.text);
    } else {
      Cookies.remove('selectedEinheit');
      Cookies.remove('selected_einheit');
    }

    // Zelt und Kind werden beim Einheitswechsel bewusst NICHT verworfen, damit
    // man fürs selbe Kind einfach die nächste Schicht wählen kann. Ob das
    // behaltene Kind in der neuen Einheit noch wählbar ist, prüft der
    // kinderFuerBewerbung-Effekt und setzt es bei Bedarf zurück.
  };

  const handleKindChange = (e) => {
    const kindId = e.target.value;
    setSelectedKind(kindId);
    if (kindId) {
      const selectedOption = e.target.options[e.target.selectedIndex];
      setSelectedKindName(selectedOption.text);
    } else {
      setSelectedKindName("");
    }
  };

  const getFilteredJobsForPriority = (priority) => {
    const selectedJobs = [];
    for (let i = 50; i >= 10; i -= 10) {
      const selectElement = document.querySelector(`select[name="${i}"]`);
      if (selectElement && selectElement.value) {
        selectedJobs.push(selectElement.value);
      }
    }
    return filteredJobs
      .filter(job => !selectedJobs.includes(job.JobID)) // Exclude already selected jobs
      .sort((a, b) => a.JobName.localeCompare(b.JobName)); // Sort alphabetically by job name
  };

  const handleRandomSelection = () => {
    const availableJobs = getFilteredJobsForPriority(50);
    for (let i = 50; i >= 10; i -= 10) {
      const selectElement = document.querySelector(`select[name="${i}"]`);
      if (selectElement && !selectElement.value && availableJobs.length > 0) {
        const randomIndex = Math.floor(Math.random() * availableJobs.length);
        selectElement.value = availableJobs[randomIndex].JobID;
        availableJobs.splice(randomIndex, 1); // Remove selected job from available jobs
      }
    }
    // Auswahl-Status, filled-Markierung und disabled-Optionen nachziehen
    handlePriorityChange();
  };

  const handlePriorityChange = () => {
    const selectedJobs = new Set();
    for (let i = 50; i >= 10; i -= 10) {
      const selectElement = document.querySelector(`select[name="${i}"]`);
      if (selectElement) {
        const wrapper = selectElement.closest('.dropdown-wrapper');
        if (selectElement.value) {
          selectedJobs.add(selectElement.value);
          wrapper && wrapper.classList.add('filled');
        } else {
          wrapper && wrapper.classList.remove('filled');
        }
      }
    }
    setHasSelection(selectedJobs.size > 0);

    for (let i = 50; i >= 10; i -= 10) {
      const selectElement = document.querySelector(`select[name="${i}"]`);
      const options = selectElement.options;
      for (let j = 0; j < options.length; j++) {
        if (selectedJobs.has(options[j].value) && options[j].value !== selectElement.value) {
          options[j].disabled = true;
        } else {
          options[j].disabled = false;
        }
      }
    }
  };

  return (
    <div className="bewerbung">
      <div className="page-header">
        {page !== 3 && <BackArrow to="/jobportal" />}
        {page === 1 && <h1 className="bewerbung-title">BEWERBUNG ABSENDEN</h1>}
      </div>
      {page === 1 && ( // Seite 1: Auswahl Einheit, Zelt, Kind
        <div className="bewerbung-form dropdown-form">
          <label>
            Einheit
            <div className={`dropdown-wrapper ${selectedEinheit ? 'filled' : ''}`}>
              <select onChange={handleEinheitChange} value={selectedEinheit}>
                <option value="">Wähle eine Einheit</option>
                {einheiten.map(einheit => (
                  <option key={einheit.ID} value={einheit.ID}>{einheit.Name}</option>
                ))}
              </select>
              <MdKeyboardArrowDown className="dropdown-chevron" />
            </div>
          </label>
          <label>
            Zelt
            <div className={`dropdown-wrapper ${selectedZelt ? 'filled' : ''}`}>
              <select onChange={handleZeltChange} value={selectedZelt}>
                <option value="">{selectedZeltName || 'Wähle ein Zelt'}</option>
                {zelte.map(zelt => (
                  <option key={zelt.ZeltID} value={zelt.ZeltID}>{zelt.Zeltname}</option>
                ))}
              </select>
              <MdKeyboardArrowDown className="dropdown-chevron" />
            </div>
          </label>
          <label>
            Kind
            <div className={`dropdown-wrapper ${selectedKind ? 'filled' : ''}`}>
              <select value={selectedKind} onChange={handleKindChange}>
                {selectedZelt && selectedEinheit && kinder.length === 0 && !selectedKind ? (
                  <option value="" disabled>Alle Kinder haben sich schon beworben</option>
                ) : (
                  <>
                    <option value="">Wähle ein Kind</option>
                    {/* Behaltenes Kind anzeigbar halten, solange die Kinder-Liste
                        (z. B. vor Auswahl der nächsten Einheit) noch leer ist. */}
                    {selectedKind && !kinder.some(kind => Number(kind.KindID) === Number(selectedKind)) && (
                      <option value={selectedKind}>{selectedKindName || 'Gewähltes Kind'}</option>
                    )}
                    {kinder.map(kind => (
                      <option key={kind.KindID} value={kind.KindID}>{kind.Name}</option>
                    ))}
                  </>
                )}
              </select>
              <MdKeyboardArrowDown className="dropdown-chevron" />
            </div>
          </label>
          <button className="bewerbung-button" onClick={handleNext} disabled={!selectedEinheit || !selectedZelt || !selectedKind}>WEITER</button>
        </div>
      )}
      {page === 2 && ( // Seite 2: Jobauswahl mit Prioritäten
        <div className="bewerbung-form dropdown-form">
          <div className="back-link">
            <span className="back-link" onClick={handleBack}>{kinder.find(kind => kind.KindID === Number(selectedKind))?.Name || selectedKindName || 'Kind nicht ausgewählt'}</span>
          </div>
          <label>
            Prio 1
            <div className="dropdown-wrapper">
              <select name="50" onChange={handlePriorityChange}>
                <option value="">Wähle einen Job</option>
                {filteredJobs.map(job => (
                  <option key={job.JobID} value={job.JobID}>{job.JobName} - {job.Slots}</option>
                ))}
              </select>
              <MdKeyboardArrowDown className="dropdown-chevron" />
            </div>
          </label>
          <label>
            Prio 2
            <div className="dropdown-wrapper">
              <select name="40" onChange={handlePriorityChange}>
                <option value="">Wähle einen Job</option>
                {filteredJobs.map(job => (
                  <option key={job.JobID} value={job.JobID}>{job.JobName} - {job.Slots}</option>
                ))}
              </select>
              <MdKeyboardArrowDown className="dropdown-chevron" />
            </div>
          </label>
          <label>
            Prio 3
            <div className="dropdown-wrapper">
              <select name="30" onChange={handlePriorityChange}>
                <option value="">Wähle einen Job</option>
                {filteredJobs.map(job => (
                  <option key={job.JobID} value={job.JobID}>{job.JobName} - {job.Slots}</option>
                ))}
              </select>
              <MdKeyboardArrowDown className="dropdown-chevron" />
            </div>
          </label>
          <label>
            Prio 4
            <div className="dropdown-wrapper">
              <select name="20" onChange={handlePriorityChange}>
                <option value="">Wähle einen Job</option>
                {filteredJobs.map(job => (
                  <option key={job.JobID} value={job.JobID}>{job.JobName} - {job.Slots}</option>
                ))}
              </select>
              <MdKeyboardArrowDown className="dropdown-chevron" />
            </div>
          </label>
          <label>
            Prio 5
            <div className="dropdown-wrapper">
              <select name="10" onChange={handlePriorityChange}>
                <option value="">Wähle einen Job</option>
                {filteredJobs.map(job => (
                  <option key={job.JobID} value={job.JobID}>{job.JobName} - {job.Slots}</option>
                ))}
              </select>
              <MdKeyboardArrowDown className="dropdown-chevron" />
            </div>
          </label>
          <div className="page2-form-actions"> {/* Neuer Container für Aktionen unten */}
            <button className="absenden-button" onClick={handleSubmit} disabled={!hasSelection}>ABSENDEN</button>
            <span className="random-text" onClick={handleRandomSelection}>
              <MdOutlineCasino /> Zufällig auffüllen
            </span>
            <div className="bottom-space" />
          </div>
        </div>
      )}
      {page === 3 && ( // Seite 3: Erfolgsmeldung
        <div className="success-message">
          <h2>Bewerbung<br />erfolgreich abgeschickt!</h2>
          <div className="success-links">
            <Link to="/home" className="success-link">
              <span className="material-symbols-outlined menu-icon">menu</span>
              <span className="link-text">Übersicht Zeltbetreuung</span>
            </Link>
            <span className="success-link" onClick={handleReset}>
              <span className="material-symbols-outlined add-icon">add</span>
              <span className="link-text">Weitere Bewerbung</span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Bewerbung;
